export default __webpack_public_path__ + "static/media/Login-screen.3ba13576.png";